export namespace Constants {
	export const KEY_ENTER = 13;
	export const LOGIN_TYPE = 'loginType';

	export const Corporate_Type: string = 'Corporate';
	export const Retail_Type: string = 'Retail';

	//userStatus
	export const Blocked_Status: string = 'BLOCKED';
	export const Init_Status: string = 'INIT';
	export const New_Status: string = 'NEW';
	export const Self_Blocked_Status: string = 'SELFBLOCKED';
}
